import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-format-line-spacing",
  templateUrl: "./med-icon-format-line-spacing.component.html",
})
export class MedIconFormatLineSpacingComponent extends SvgMixinComponent {}
